import { render, staticRenderFns } from "./tax_event_row.vue?vue&type=template&id=bad4f508&scoped=true"
import script from "./tax_event_row.vue?vue&type=script&lang=js"
export * from "./tax_event_row.vue?vue&type=script&lang=js"
import style0 from "./tax_event_row.vue?vue&type=style&index=0&id=bad4f508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad4f508",
  null
  
)

export default component.exports